import { CSharpLanguage as CSharpLanguage } from "./CSharpLanguage";

export class GodotLibrary
{
  public static readonly token = "godot c#";
  public static keywords:string[] = 

  CSharpLanguage.keywords.concat(
    [
      "partial","override","virtual"
    ]
  )

  public static keywords2:string[] = 
  [    
    "Rokojori", "Godot","Export","Task",
    "Tool", "GlobalClass",

    "Vector2","Vector3","Vector4",
    "Transform3D",
    
    "Node","Node3D","Node2D",

    "Resource",
    
    "Action","ActionList","ActionSequence", 
    "SequenceAction","Parallel",

    "GD", "SceneTreeTimer"

  ]
  
}